var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60.809 60.795",
    style: {
      enableBackground: "new 0 0 60.809 60.795"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EBEBEB;}\n\t.st1{fill:none;stroke:#4FB8C2;stroke-width:2;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#4FB8C2;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#4FB8C2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#4FB8C2;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#4FB8C2;}\n\t.st6{fill:#404040;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:none;stroke:#4FB8C2;stroke-miterlimit:10;}\n\t.st9{enable-background:new    ;}\n\t.st10{fill:#303B84;}\n\t.st11{fill:#A7DBE0;}\n\t.st12{fill:none;stroke:#4FB8C2;stroke-width:2.5;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#404040;stroke-miterlimit:10;}\n\t.st14{fill:#B3B3B3;}\n\t.st15{fill:#FF3732;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.809,30.399C59.809,46.633,46.646,59.795,30.4,59.795C14.162,59.795,1,46.633,1,30.399 C1,14.161,14.162,1,30.4,1C46.646,1,59.809,14.16101,59.809,30.399z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.319,35.96101c0,0,0,4.491,0,4.672s0.337,1.996-11.51,5.011"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.491,35.96101c-0.005,1.479,0,4.491,0,4.672s-0.336,1.996,11.51,5.011"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.075,36.69401c1.605-0.385,2.426-1.104,2.426-1.104c2.719-1.93,4.403-7.983,4.911-12.227 c0.748-6.248-0.116-13.722-11.008-13.969c-10.89,0.247-11.754,7.721-11.004,13.969c0.507,4.241,2.192,10.297,4.909,12.227 c0,0,0.821,0.719,2.426,1.104"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.3d6f1fcc9057a9bf68f23abf8a1eaad1.svg";
export { ForwardRef as ReactComponent };